import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { VillainSection } from './components/VillainSection';
import { SolutionSection } from './components/SolutionSection';
import { Testimonials } from './components/Testimonials';
import { ValueStack } from './components/ValueStack';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { LiveSalesNotification } from './components/LiveSalesNotification';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-brand-text font-sans selection:bg-brand-gold selection:text-brand-darker" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainSection data-id="element-4" />
        <VillainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <ValueStack data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <LiveSalesNotification data-id="element-12" />
    </div>;
}